import React from "react";
import { Modal, ModalBody, ModalHeader, Spinner, Alert } from "reactstrap";

interface DownloadModalProps {
  isOpen: boolean;
  toggle: () => void;
  status: "idle" | "in_progress" | "success" | "error" | "pending";
  permitNo?: string;
  errorMessage?: string;
  message?: string;
}

const DownloadModal: React.FC<DownloadModalProps> = ({
  isOpen,
  toggle,
  status,
  permitNo,
  message,
  errorMessage
}) => {
  // Only show close button when there's an error
  const showCloseButton = status === "error";
  
  return (
    <Modal 
      isOpen={isOpen} 
      toggle={showCloseButton ? toggle : undefined} 
      centered
      backdrop={status === "error" ? true : "static"} // Prevent closing by clicking outside
      keyboard={false} // Prevent closing with ESC key
    >
      <ModalHeader toggle={showCloseButton ? toggle : undefined}>
        {status === "success" ? "PDF Ready" : "Generating PDF"}
      </ModalHeader>
      <ModalBody className="text-center">
        {status === "pending" || status === "in_progress" ? (
          <>
            <Spinner color="primary" className="mb-3" />
            <p>{message || `Generating PDF for permit ${permitNo}...`}</p>
            <p className="text-muted small">This may take a moment</p>
          </>
        ) : status === "success" ? (
          <Alert color="success">
            <i className="ri-checkbox-circle-line fs-3" />
            <p className="mt-2">{message || "PDF ready!"}</p>
          </Alert>
        ) : status === "error" ? (
          <Alert color="danger">
            <i className="ri-error-warning-line fs-3" />
            <p className="mt-2">{errorMessage}</p>
          </Alert>
        ) : null}
      </ModalBody>
    </Modal>
  );
};

export default DownloadModal;